module.exports = __webpack_public_path__ + "assets/img/HotSpotting.cd54419d.png";